module.exports = __webpack_public_path__ + "2f9ed5cf203b33953a05affb9ac5b6c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-14-harrison/diary.jpg
// module id = 745
// module chunks = 0